import { render } from "./NewSalaryEdit.vue?vue&type=template&id=74671a6c"
import script from "./NewSalaryEdit.vue?vue&type=script&lang=js"
export * from "./NewSalaryEdit.vue?vue&type=script&lang=js"

import exportComponent from "D:\\VueProject\\everlife-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__